export const NpaPropertiesList= [
  { id: 1, label: "PROPERTY ID" },
  { id: 2, label: "BORROWER NAME"},
  { id: 3, label: "BANK NAME" },
  { id: 4, label: "PRICE" },
  { id: 5, label: "AUCTION START"},
  { id: 6, label: "AUCTION END"},
  { id: 7, label: "STATUS"},
  { id: 8, label: "ASSET CATEGORY"},
  { id: 9, label: "POSSESSION TYPE"},
  { id: 10, label: "PROPERTY TYPE"},
  { id: 10, label: "TOTAL INQUIRY"},
  // { id: 11, label: "INQUIRY VIEW"},
  { id: 12, label: "ACTIONS"},
];

export const NpaInquiryList = [
  { id: 1, label: "PROPERTY ID" },
  { id: 2, label: "NAME"},
  { id: 3, label: "MOBILE NUMBER" },
  { id: 4, label: "EMAIL ADDRESS" },
  { id: 5, label: "PROPERTY TYPE" },
  { id: 6, label: "POSSESSION TYPES" },
  { id: 7, label: "INQUIRY CREATED" },
  { id: 8, label: "ACTIONS" },
  ];

export const AllUsersList = [
  { id: 1, label: "NAME"},
  { id: 2, label: "MOBILE NUMBER" },
  { id: 3, label: "EMAIL ADDRESS" },
  { id: 4, label: "DESIGNATION" },
  { id: 5, label: "BANK NAME" },
  { id: 6, label: "CITY" },
  { id: 7, label: "USER CREATED" },
  { id: 8, label: "STATUS" },
  { id: 9, label: "ACTIONS" },
]

export const RequestedUserList = [
  { id: 1, label: "NAME"},
  { id: 2, label: "MOBILE NUMBER" },
  { id: 3, label: "EMAIL ADDRESS" },
  { id: 4, label: "DESIGNATION" },
  { id: 5, label: "BANK NAME" },
  { id: 6, label: "CITY" },
  { id: 7, label: "USER CREATED" },
  { id: 9, label: "ACTIONS" },
]
  
export const ApprovedUserList = [
  { id: 1, label: "NAME"},
  { id: 2, label: "MOBILE NUMBER" },
  { id: 3, label: "EMAIL ADDRESS" },
  { id: 4, label: "DESIGNATION" },
  { id: 5, label: "BANK NAME" },
  { id: 6, label: "CITY" },
  { id: 7, label: "USER CREATED" },
  { id: 8, label: "STATUS" },
  { id: 9, label: "ACTIONS" },
]